module.exports = __webpack_public_path__ + "img/goal-heart.70f211d1.svg";